import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import cn from 'classnames';

import RichText from 'components/rich-text';
import isRunningOnClient from '@creuna/utils/is-running-on-client';
import Icon from 'components/icon';

const GLOBAL_WARNING_SESSION_STORAGE_ID = 'global-warning-closed';

const GlobalWarningBlock = ({
  textAsHtml,
  closeButtonText,
  changeCallback
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOnClose = () => {
    setIsOpen(false);

    if (!isRunningOnClient) return;
    if (!sessionStorage) return;

    sessionStorage.setItem(GLOBAL_WARNING_SESSION_STORAGE_ID, 'viewed');

    changeCallback && changeCallback();
  };

  useEffect(() => {
    if (!isRunningOnClient) return;
    if (!sessionStorage) return;

    const isViewed = sessionStorage.getItem(GLOBAL_WARNING_SESSION_STORAGE_ID);

    if (!isViewed) {
      setIsOpen(true);
      changeCallback && changeCallback();
    }
  }, []);

  return (
    <div
      id="global-warning-block"
      className={cn('global-warning-block', {
        'global-warning-block--active': isOpen
      })}
    >
      <div className="global-warning-block__content-wrapper">
        <div className="global-warning-block__text-wrapper">
          <RichText
            html={textAsHtml}
            themes={[RichText.themes.globalWarningBlock]}
          />
        </div>
        {closeButtonText && (
          <button
            className="global-warning-block__button"
            onClick={handleOnClose}
            aria-label={closeButtonText}
          >
            <span className="global-warning-block__button__text">
              {closeButtonText}
            </span>
            <Icon className="global-warning-block__button__icon" name="x" />
          </button>
        )}
      </div>
    </div>
  );
};

GlobalWarningBlock.propTypes = {
  textAsHtml: PropTypes.string,
  closeButtonText: PropTypes.string,
  changeCallback: PropTypes.func
};

GlobalWarningBlock.propTypesMeta = {
  changeCallback: 'exclude'
};

export default GlobalWarningBlock;
